import { render, staticRenderFns } from "./zflb.vue?vue&type=template&id=4874175b&scoped=true&"
import script from "./zflb.vue?vue&type=script&lang=js&"
export * from "./zflb.vue?vue&type=script&lang=js&"
import style0 from "./zflb.vue?vue&type=style&index=0&id=4874175b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4874175b",
  null
  
)

export default component.exports